export default __webpack_public_path__ + "static/media/img_pdf_2.0d10861d.png";